import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from 'react'
import { keys, pick } from 'lodash-es'
import { Drawer } from '@mantine/core'
import { Statistics } from '@ow/ditto'
import { useTbViewStore } from '@vt/hooks'

const StatisticsDrawer = (props, ref) => {
  const [open, setOpen] = useState(false)
  const [currentFiled, setCurrentFiled] = useState()
  const [statisticsData, setStatisticsData] = useState()
  const { ditto, tbData, fields, statisticsConfig } = useTbViewStore((state) =>
    pick(state, ['ditto', 'tbData', 'fields', 'statisticsConfig'])
  )
  const { slugs: calSlugs = [] } = statisticsConfig || {}

  const fetchCount = (slug) => {
    ditto
      .fetchCountGroupBy(slug, {
        filters: {},
      })
      .then((res) => {
        setStatisticsData(res[slug])
      })
  }

  const calSlugInfo = (fieldSlug, optionSlug) => {
    return tbData
      .filter((d) => {
        const value = d[currentFiled.slug]
        return value && (value === optionSlug || value.includes(optionSlug))
      })
      .map((v) => {
        return v[fieldSlug]
      })
  }

  const statisticsArr = useMemo(() => {
    return (
      currentFiled &&
      keys(statisticsData || {}).map((v) => {
        const obj = {}
        calSlugs.forEach((c) => {
          obj[c] =
            (statisticsData[v] && statisticsData[v][c]) ||
            calSlugInfo(c, v.num || v)
        })

        const num =
          (statisticsData[v] && statisticsData[v].num) || statisticsData[v]
        return { slug: v, num, ...obj }
      })
    )
  }, [statisticsData, currentFiled])

  useImperativeHandle(ref, () => {
    return {
      open: (field) => {
        fetchCount(field && field.slug)
        setCurrentFiled(field)
        setOpen(true)
      },
      close: () => {},
    }
  })

  return (
    <Drawer
      opened={open}
      onClose={() => {
        setCurrentFiled(null)
        setOpen(false)
      }}
      title={currentFiled ? `统计-${currentFiled.title}` : '统计'}
      padding="xl"
      size="xl"
      position="right"
      styles={{
        title: { fontSize: '14px', fontWeight: 'bold' },
        header: {
          borderBottom: '1px solid #E7E7E7',
          padding: '0 0 10px 0',
        },
        root: { top: '64px !important' },
        drawer: { top: '64px', maxHeight: 'calc(100vh - 64px)' },
        closeButton: {
          '&:focus': {
            outline: 'none',
          },
        },
      }}
    >
      <Statistics
        extCloumns={fields.filter((v) => calSlugs.includes(v.slug))}
        data={statisticsArr}
        opts={currentFiled}
      />
    </Drawer>
  )
}
export default forwardRef(StatisticsDrawer)
